export const DEFAULT_DISPLAY_SETTINGS = {
  showFat: 1,
  showScc: 1,
  showAlcohol68: 1,
  showAlcohol70: 1,
  showAlcohol72: 1
};

const DISPLAY_SETTING_KEYS = Object.keys(DEFAULT_DISPLAY_SETTINGS);

const normalizeFlag = (value) => (value === 0 || value === '0' ? 0 : 1);

export const normalizeDisplaySettings = (raw) => ({
  showFat: normalizeFlag(raw?.showFat ?? 1),
  showScc: normalizeFlag(raw?.showScc ?? 1),
  showAlcohol68: normalizeFlag(raw?.showAlcohol68 ?? 1),
  showAlcohol70: normalizeFlag(raw?.showAlcohol70 ?? 1),
  showAlcohol72: normalizeFlag(raw?.showAlcohol72 ?? 1)
});

export const andDisplaySettings = (...settingsList) => {
  const result = { ...DEFAULT_DISPLAY_SETTINGS };
  DISPLAY_SETTING_KEYS.forEach((key) => {
    result[key] = settingsList.every((settings) => normalizeFlag(settings?.[key] ?? 1) === 1)
      ? 1
      : 0;
  });
  return result;
};

export const resolveDisplaySettings = (userOrSettings) => {
  const raw = userOrSettings?.displaySettings || userOrSettings || {};
  return normalizeDisplaySettings(raw);
};

export const canShowFat = (settings) => resolveDisplaySettings(settings).showFat === 1;
export const canShowScc = (settings) => resolveDisplaySettings(settings).showScc === 1;
export const canShowAlcohol68 = (settings) => resolveDisplaySettings(settings).showAlcohol68 === 1;
export const canShowAlcohol70 = (settings) => resolveDisplaySettings(settings).showAlcohol70 === 1;
export const canShowAlcohol72 = (settings) => resolveDisplaySettings(settings).showAlcohol72 === 1;

export const canShowAlcoholPercent = (settings, percentage) => {
  const pct = String(percentage);
  if (pct === '68') return canShowAlcohol68(settings);
  if (pct === '70') return canShowAlcohol70(settings);
  if (pct === '72') return canShowAlcohol72(settings);
  return true;
};
